import { Button } from "antd";
import { GetAntIcon } from "../../utils/ant_icons";

interface ReportingExportButtonProps {
	onExport: () => void;
	isLoading: boolean;
	// A link on a dark header bar; "default" gives an outlined button.
	type?: "link" | "default";
}

function ReportingExportButton(props: ReportingExportButtonProps) {
	const { onExport, isLoading, type = "link" } = props;

	return (
		<Button
			type={type}
			icon={GetAntIcon("export")}
			onClick={onExport}
			loading={isLoading}
		>
			Export
		</Button>
	);
}

export default ReportingExportButton;
